// extracted by mini-css-extract-plugin
export default {"auth-form":"AuthForm_auth-form__hyUFN","dark":"AuthForm_dark__YKn5U"};